import React from "react";
import { Link } from "gatsby";
export default function Footer() {
  return (
    <>
      <footer className="footer bg-white p-2 mt-8 border-t">
        <div className="container mx-auto pt-8">
          <div className="flex flex-wrap">
            <div className="w-full md:w-1/2 mb-4">
              <div className="w-4/5">
                <p className="font-bold text-2xl mb-2">About</p>
                <p className="font-medium">
                  I built this site as a pet project. Creating a receipt should
                  be easy and free. If you like this site or have a suggestion
                  feel free to{" "}
                  <a
                    className="text-purple-600 hover:underline"
                    href="mailto:dipankarmaikap77@gmail.com?subject=Hello&body"
                  >
                    say hello
                  </a>
                  . Feedback is always appreciated!
                </p>
              </div>
            </div>
            <div className="w-full md:w-1/2 mb-4">
              <div className="flex flex-wrap">
                <div className="w-full md:w-1/3 mb-4">
                  <p className="text-lg font-bold">Built With</p>
                  <ul className="mt-2 text-purple-600 font-medium  space-y-2">
                    <li>
                      <a
                        href="https://tailwindcss.com/"
                        rel="noreferrer"
                        target="_blank"
                        className="hover:underline"
                      >
                        Tailwind CSS
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.gatsbyjs.com/"
                        rel="noreferrer"
                        target="_blank"
                        className="hover:underline"
                      >
                        Gatsby JS
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.netlify.com/"
                        rel="noreferrer"
                        target="_blank"
                        className="hover:underline"
                      >
                        Netlify
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="w-full md:w-1/3 mb-4">
                  <p className="text-lg font-bold">Share</p>
                  <ul className="mt-2 text-purple-600 font-medium space-y-2">
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://twitter.com/intent/tweet?text=Generate your business receipt with https://receiptmaker.netlify.app/ (via @maikap_dipankar)"
                        className="hover:underline"
                      >
                        <i className="demo-icon icon-twitter text-lg mr-1"></i>
                        Twitter
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.facebook.com/sharer/sharer.php?u=https://receiptmaker.netlify.app/"
                        rel="noreferrer"
                        target="_blank"
                        className="hover:underline"
                      >
                        <i className="demo-icon icon-facebook text-lg mr-1"></i>
                        Facebook
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.reddit.com/submit?url=https://receiptmaker.netlify.app/"
                        rel="noreferrer"
                        target="_blank"
                        className="hover:underline"
                      >
                        <i className="demo-icon icon-reddit-alien text-lg mr-1"></i>
                        Reddit
                      </a>
                    </li>
                    <li>
                      <a
                        href="mailto:?subject=I wanted you to see this site&amp;body=Check out this site https://receiptmaker.netlify.app/."
                        className="hover:underline"
                      >
                        <i className="demo-icon icon-mail text-lg mr-1"></i>
                        Email
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="w-full md:w-1/3 mb-4">
                  <p className="text-lg font-bold">Links</p>
                  <ul className="mt-2 text-purple-600 font-medium space-y-2">
                    <li>
                      <a
                        href="https://dipankarmaikap.com/"
                        rel="noreferrer"
                        target="_blank"
                        className="hover:underline"
                      >
                        My Site
                      </a>
                    </li>
                    <li>
                      <Link className="hover:underline" to="/privacy-policy/">
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link className="hover:underline" to="/terms-of-service/">
                        Terms Of Service
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t">
          <div className="container mx-auto ext-center py-1 pt-3 font-medium">
            © {new Date().getFullYear()}{" "}
            <a className="hover:underline" href="https://dipankarmaikap.com">
              Dipankar Maikap
            </a>{" "}
            | Crafted with{" "}
            <span role="img" aria-label="love icon">
              ❤️
            </span>
          </div>
        </div>
      </footer>
    </>
  );
}
